const config = {
  development: {
    enabled: false,
    trackingId: '',
    debug: false,
  },
  staging: {
    enabled: false,
    trackingId: 'UA-107408630-1',
    debug: false,
  },
  production: {
    enabled: true,
    trackingId: 'UA-107408630-1',
    debug: false,
  },
};

export default config;
